import { BaseService } from 'core/services';
import { VerificationRouteService } from 'common/data';

class VerificationService extends BaseService {
	constructor(apiClient) {
		super(apiClient, new VerificationRouteService());
	}

	sendVerificationCode = async sendVerificationCodeParams => {
		var url = this.routeService.sendVerificationCode(sendVerificationCodeParams);
		return this.apiClient.post(url, sendVerificationCodeParams);
	};

	validateVerificationCode = async validateVerificationCodeParams => {
		var url = this.routeService.validateVerificationCode(validateVerificationCodeParams);
		return this.apiClient.post(url, validateVerificationCodeParams);
	};
}

export default VerificationService;



// WEBPACK FOOTER //
// ./src/common/data/services/VerificationService.js